<div #strip *ngIf="swUpdateService.updateAvailable() || refreshing" class="update-strip" role="status" aria-live="polite">
  <span class="update-strip__text">
    <span class="update-strip__title">New version available.</span>
    <span class="update-strip__subtitle">Refresh to get the latest updates.</span>
  </span>

  <button type="button"
          class="update-strip__button"
          [disabled]="refreshing"
          (click)="refreshNow()">
    {{ refreshing ? 'Refreshing…' : 'Refresh now' }}
  </button>
</div>
